<template>
    <div class="bg-white text-dark p-1 px-1 px-md-2 px-lg-4">
        <!--/* Version desktop */-->
        <div class="d-none d-md-flex align-items-center">
            <p class="mb-0" v-html="currentContractLabel" />
            <template v-if="showContractSelectorPageLink">
                <p class="mb-0 mx-1">
                    |
                </p>
                <a
                    class="ob1-link-arrow"
                    data-oevent-category="fiche_option"
                    data-oevent-action="changer_de_contrat"
                    :href="contractSelectorPageLinkUrl"
                    :data-oevent-label="contractSelectorPageLinkUrl"
                    v-text="contractSelectorPageLinkLabel"
                />
            </template>
        </div>
        <!--/* Version mobile */-->
        <div class="d-block d-md-none text-start">
            <p class="mb-0 py-0" v-html="currentContractLabel" />
            <template v-if="showContractSelectorPageLink">
                <a
                    class="ob1-link-arrow ob1-link-small pb-0"
                    data-oevent-category="fiche_option"
                    data-oevent-action="changer_de_contrat"
                    :href="contractSelectorPageLinkUrl"
                    :data-oevent-label="contractSelectorPageLinkUrl"
                    v-text="contractSelectorPageLinkLabel"
                />
            </template>
        </div>
    </div>
</template>

<script>

export default {
    name: "OptionHeaderContractInfo",
    props: {
        currentContractLabel: {
            type: String,
            required: true
        },
        contractSelectorPageLinkLabel: {
            type: String,
            default: undefined
        },
        contractSelectorPageLinkUrl: {
            type: String,
            default: undefined
        }
    },
    computed: {
        showContractSelectorPageLink() {
            return (this.contractSelectorPageLinkLabel) && (this.contractSelectorPageLinkUrl)
        }
    }
}
</script>
